module.exports = __webpack_public_path__ + "img/组44@2x.5753daf7.png";